<div [@routerTransition]>
    <sub-header [title]="('PurchaseOrders' | localize) + ' ' + ('Details' | localize)"
        [breadcrumbs]="breadcrumbs"></sub-header>

    <div [class]="containerClass">
        <div class="card card-custom gutter-b">
            <div class="card-body">
                <div class="row mt-3">
                    <div class="col-md-3">
                        <div class="form-group">
                            <label for="VendorDisplayProperty">{{ l('Vendor') }}</label>
                            <app-search-vendor (vendorEvent)="getVendor($event)" [vendorSelectedItem]="this.vendorSelectedItem"> </app-search-vendor>
                        </div>
                    </div>
                    <div class="col-md-2">
                        <div class="form-group">
                            <label for="PurchaseOrder_PDate">{{ l('PDate') }}</label>
                            <abp-datetime-picker #PurchaseOrder_date="ngModel" [(ngModel)]="purchaseOrder.date"
                                                 id="PurchaseOrder_date" name="PurchaseOrder_date"
                                                 [bsConfig]="{ adaptivePosition: true }"
                                                 displayFormat="DD/MM/YYYY"></abp-datetime-picker>

                            <validation-messages [formCtrl]="PurchaseOrder_date"></validation-messages>
                        </div>
                    </div>
                    <div class="col-md-2">
                        <div class="form-group">
                            <label for="PurchaseOrder_ReferenceNo">{{ l('ReferenceNo') }}</label>
                            <input type="text" #PurchaseOrder_ReferenceNo="ngModel" id="PurchaseOrder_ReferenceNo"
                                class="form-control" [(ngModel)]="purchaseOrder.referenceNo" name="ReferenceNo" />
                            <validation-messages [formCtrl]="PurchaseOrder_ReferenceNo"></validation-messages>
                        </div>
                    </div>
                    <div class="col-md-2">
                        <div class="form-group m-form__group">
                            <label for="PaymentTermName">{{ l('PaymentTerm') }}</label>
                            <select name="purchaseOrder.paymentTermId" [(ngModel)]="purchaseOrder.paymentTermId"
                                class="form-select">
                                <option value="">{{ l('SelectAPaymentTerm') }}</option>

                                <option *ngFor="let item of allPaymentTerms" value="{{ item.id }}">
                                    {{ item.displayName }}
                                </option>
                            </select>
                        </div>
                    </div>
                    <div class="col-md-2">
                        <div class="form-group">
                            <label for="PurchaseOrder_TaxType">{{ l('TaxType') }}</label>
                            <select #PurchaseOrder_TaxType="ngModel" class="form-select" name="TaxType" (change)="calculateTotalValues()"
                                id="PurchaseOrder_TaxType" [(ngModel)]="purchaseOrder.taxType">
                                <option value="1">{{ l('Normal') }}</option>

                                <option value="2">{{ l('Inclusive') }}</option>
                            </select>
                            <validation-messages [formCtrl]="PurchaseOrder_TaxType"></validation-messages>
                        </div>
                    </div>
                    <div class="col-md-2">
                        <div class="form-group m-form__group">
                            <label for="CurrencyName">{{ l('Currency') }}</label>
                            <select name="purchaseOrder.currencyId" (change)="getCurrencyRate($event)" [(ngModel)]="purchaseOrder.currencyId"
                                    class="form-select">
                                <option value="null">{{ l('SelectACurrency') }}</option>

                                <option *ngFor="let item of allCurrencys" value="{{ item.id }}">
                                    {{ item.name }}
                                </option>
                            </select>
                        </div>
                    </div>
                    <div class="col-md-2">
                        <div class="form-group">
                            <label for="PurchaseOrder_CurrencyRate">{{ l('CurrencyRate') }}</label>
                            <input type="text" appAllowDecimal id="PurchaseOrder_CurrencyRate"
                                   class="form-control text-end" [(ngModel)]="purchaseOrder.currencyRate"
                                   (ngModelChange)="calculateTotalValues()"
                                   name="CurrencyRate" />
                        </div>
                    </div>
                </div>
                <div class="row mt-3">
                    <div class="col-md-12">
                        <table class="table table-bordered">
                            <thead>
                                <tr>
                                    <th width="5%">#</th>
                                    <th width="10%">{{ l('ItemCode') }}</th>
                                    <th width="30%">{{ l('ItemName') }}</th>
                                    <th width="8%">{{ l('Qty') }}</th>
                                    <th width="8%">{{ l('UOM') }}</th>
                                    <th width="8%">{{ l('Cost') }}</th>
                                    <th width="8%">{{ l('FocQty') }}</th>
                                    <th width="8%">{{ l('DiscAmtPer') }}</th>
                                    <th width="8%">{{ l('DiscAmount') }}</th>
                                    <th width="10%">{{ l('Tax') }}</th>
                                    <th width="10%">{{ l('Total') }}</th>
                                    <th width="5%">{{ l('Action') }}</th>
                                </tr>
                            </thead>
                            <tbody>

                                <tr *ngFor="let data of purchaseDetails; let i = index">
                                    <td class="text-center">
                                        <div class="d-flex align-items-center">
                                            <button class="btn btn-danger d-flex align-items-center justify-content-center p-0 rounded-circle"
                                                    style="width: 30px; height: 30px" (click)="removeItem(i)">
                                                x
                                            </button>
                                            <span class="ps-1"><b>{{ data.slNo }}</b></span>
                                        </div>
                                        <!-- (click)="removeItem(i)" -->
                                    </td>
                                    <td> <input type="text" #itemCodeInput class="form-control" [(ngModel)]="data.productCode" (keydown.enter)="searchProduct(data.productCode,data,i)" (blur)="searchProduct(data.productCode,data,i)"  /> </td>
                                    <td>
                                        <app-search-product (productEvent)="getProduct($event,data,i)" [productSelectedItem]="data.productSelectedItem"> </app-search-product>
                                    </td>
                                    <td><input type="text" #qtyInput (keydown.enter)="focusNext('cost', i)" class="form-control text-end" appAllowDecimal [(ngModel)]="data.qty" (ngModelChange)="amountCalculate(data)" /></td>
                                    <td>
                                        <a *ngIf="!data.changeUnitFlag" (click)="changeUnit(data)"><span><b> {{data.unitName}} </b> </span> </a>
                                        <select name="data.unitId" *ngIf="data.changeUnitFlag"
                                                [(ngModel)]="data.unitId"
                                                class="form-select"
                                                required>
                                            
                                            <option *ngFor="let item of data.applicableUnits" value="{{ item.unitId }}">
                                                {{ item.name }}
                                            </option>
                                        </select>
                                    </td>
                                    <td><input type="text" #costInput (keydown.enter)="focusNext('focQty', i)" class="form-control text-end" appAllowDecimal [(ngModel)]="data.cost" (ngModelChange)="amountCalculate(data)" /></td>
                                    <td><input type="text" #focQtyInput (keydown.enter)="focusNext('itemDiscountPerc', i)" class="form-control text-end" appAllowDecimal [(ngModel)]="data.focQty"  /></td>
                                    <td><input type="text" #itemDiscountPercInput (keydown.enter)="focusNext('itemDiscount', i)" class="form-control text-end" appAllowDecimal [(ngModel)]="data.itemDiscountPerc" (ngModelChange)="amountCalculate(data)" /></td>
                                    <td><input type="text" #itemDiscountInput (keydown.enter)="focusNext('tax', i)" class="form-control text-end" appAllowDecimal [(ngModel)]="data.itemDiscount" (ngModelChange)="amountCalculate(data)" /></td>
                                    <td>
                                        <select name="data.taxId" #taxInput (change)="amountCalculate(data)" (keydown.enter)="focusNext('add', i)"
                                                [(ngModel)]="data.taxId"
                                                class="form-select">
                                            <option value="null">{{ l('None') }}</option>
                                            <option *ngFor="let item of applicableTaxes" value="{{ item.id }}">
                                                {{ item.name }}
                                            </option>
                                        </select>
                                    </td>
                                    <td><b>{{data.totalValue | priceFormat}}</b></td>
                                    <td width="5%" class="text-center">
                                        <button  #addButton (keydown.enter)="focusNext('nextRow', i)" class="btn btn-success d-flex align-items-center justify-content-center p-0 rounded-circle"
                                                style="width: 30px; height: 30px" (click)="addRow(i)" >
                                           +
                                        </button>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-12">
                        <table>
                            <tr>
                                <td width="80%" style="vertical-align: top">
                                    <div class="row" style="margin-right:8px;">
                                        <div class="col-md-8">&nbsp;&nbsp;</div>
                                        <div class="col-md-2">
                                            <div class="form-group">
                                                <label for="PurchaseOrder_PTotalValue">{{ l('PTotalValue') }}</label>
                                                <input type="number" readonly="readonly"
                                                       priceFormat
                                                       id="PurchaseOrder_PTotalValue" class="form-control text-end"
                                                       [(ngModel)]="purchaseOrder.totalValue" name="PTotalValue" />
                                            </div>
                                        </div>

                                        <div class="col-md-2">
                                            <div class="form-group">
                                                <label for="PurchaseOrder_PNetDiscountPerc">
                                                    {{ l('PNetDiscountPerc') }}
                                                </label>
                                                <input type="text" appAllowDecimal id="PurchaseOrder_PNetDiscountPerc" class="form-control text-end"
                                                       [(ngModel)]="purchaseOrder.netDiscountPerc"
                                                       name="PNetDiscountPerc" (ngModelChange)="calculateTotalValues()" />
                                            </div>
                                        </div>
                                        <div class="col-md-12">
                                            <div class="form-group">
                                                <label for="PurchaseOrder_Remarks">{{ l('Remarks') }}</label>
                                                <input type="text" 
                                                    id="PurchaseOrder_Remarks" class="form-control"
                                                    [(ngModel)]="purchaseOrder.remarks" name="Remarks" />
                                            
                                            </div>
                                        </div>
                                        <div class="col-md-2">
                                            &nbsp;
                                        </div>
                                        <div class="col-md-6">&nbsp;&nbsp;</div>
                                        <div class="col-md-2">
                                            <div class="form-group">
                                                <label for="PurchaseOrder_OtherCharges">{{ l('OtherCharges') }}</label>
                                                <input type="text" appAllowDecimal id="PurchaseOrder_OtherCharges" class="form-control text-end"
                                                       [(ngModel)]="purchaseOrder.otherCharges" name="OtherCharges"
                                                       (ngModelChange)="calculateTotalValues()" />
                                            </div>
                                        </div>
                                        <div class="col-md-2">
                                            <div class="form-group">
                                                <label for="PurchaseOrder_PRoundingAmount">
                                                    {{ l('PRoundingAmount') }}
                                                </label>
                                                <input type="text" appAllowDecimal id="PurchaseOrder_PRoundingAmount" class="form-control text-end"
                                                       [(ngModel)]="purchaseOrder.roundingAmount"
                                                       
                                                       name="PRoundingAmount" (ngModelChange)="calculateTotalValues()" />
                                            </div>
                                        </div>
                                    </div>
                                </td>
                                <td width="20%" style="vertical-align: top">
                                    <div class="row">
                                        <div class="col-md-12">
                                            <div class="form-group">
                                                <label for="PurchaseOrder_PSubTotal">{{ l('PSubTotal') }}</label>
                                                <input type="number" readonly="readonly"
                                                       id="PurchaseOrder_PSubTotal" class="form-control text-end"
                                                       [(ngModel)]="purchaseOrder.subTotal" name="PSubTotal" />

                                            </div>
                                        </div>
                                        <div class="col-md-12">
                                            <div class="form-group">
                                                <label for="PurchaseOrder_PTax">{{ l('PTax') }}</label>
                                                <input type="number"
                                                       id="PurchaseOrder_PTax" class="form-control text-end"
                                                       [(ngModel)]="purchaseOrder.tax" name="PTax" readonly="readonly" />
                                            </div>
                                        </div>
                                        <div class="col-md-12">
                                            <div class="form-group">
                                                <label for="PurchaseOrder_PGrandTotal">{{ l('PGrandTotal') }}</label>
                                                <input type="number"
                                                       id="PurchaseOrder_PGrandTotal" class="form-control text-end"
                                                       [(ngModel)]="purchaseOrder.grandTotal" name="PGrandTotal" readonly="readonly" />
                                            </div>
                                        </div>
                                        <div class="col-md-12" *ngIf="purchaseOrder.currencyId">
                                            <div class="form-group">
                                                <label for="localTotal">{{ l('PGrandTotal') }} ({{this.primaryCurrency}})</label>
                                                <input type="text" class="form-control text-end"
                                                       [(ngModel)]="localTotal" name="localTotal" readonly="readonly" />
                                            </div>
                                        </div>
                                        
                                        <div class="col-md-12">
                                            <div class="form-group">
                                                <label for="PurchaseOrder_PNetTotal">{{ l('PNetTotal') }}</label>
                                                <input type="number"
                                                       id="PurchaseOrder_PNetTotal" class="form-control text-end"
                                                       [(ngModel)]="purchaseOrder.netTotal" name="PNetTotal" readonly="readonly" />

                                            </div>
                                        </div>
                                    </div>
                                </td>
                            </tr>
                        </table>
                    </div>
                </div>
            </div>
            <div class="card-footer">
                <div class="col-lg-12 text-end">
                    <button (click)="goBack()" class="btn btn-danger me-2" [buttonBusy]="saving">
                        <i class="fa fa-close"></i>
                        <span>{{ l('Close') }}</span>
                    </button>
                    <button (click)="save(1)" class="btn btn-primary blue me-2" [buttonBusy]="saving"
                            [busyText]="l('SavingWithThreeDot')"
                            [hidden]="purchaseOrder.status != status.Draft">
                        <i class="fa fa-save"></i>
                        <span>{{ l('Save') }}</span>
                    </button>

                    <button (click)="save(4)"
                            class="btn btn-primary blue float-right" [buttonBusy]="saving"
                            [hidden]="purchaseOrder.id != null"
                            [busyText]="l('SavingWithThreeDot')">
                        <i class="fa fa-save"></i>
                        <span>{{ l('SaveAndApproved') }}</span>
                    </button>
                </div>
            </div>
        </div>
    </div>
</div>
